export default "__VITE_PUBLIC_ASSET__c5c6afa1__"